import React from "react";
import { FileText, ShieldCheck, CreditCard, KeyRound, AlertTriangle } from "lucide-react";

const SECTIONS = [
  {
    icon: KeyRound,
    title: "Podmínky pronájmu",
    items: [
      "Minimální věk řidiče je 21 let a řidičský průkaz platný alespoň 1 rok.",
      "K pronájmu je nutné předložit dva doklady totožnosti (občanský průkaz / pas a řidičský průkaz).",
      "Při převzetí vozu se skládá vratná kauce dle kategorie vozidla.",
      "Vozidlo se vrací s plnou nádrží a ve stavu, v jakém bylo převzato.",
    ],
  },
  {
    icon: ShieldCheck,
    title: "Pojištění a asistence",
    items: [
      "Každé vozidlo má sjednané povinné ručení i havarijní pojištění.",
      "V ceně je asistenční služba dostupná NONSTOP 24 hodin denně.",
      "Spoluúčast při pojistné události je uvedena ve smlouvě o pronájmu.",
    ],
  },
  {
    icon: CreditCard,
    title: "Platba a rezervace",
    items: [
      "Rezervaci lze provést online nebo telefonicky. Platí se při převzetí vozu hotově či kartou.",
      "U vybraných vozů je možná platba zálohy převodem na bankovní účet předem.",
      "Storno rezervace je zdarma nejpozději 24 hodin před převzetím vozu.",
    ],
  },
  {
    icon: AlertTriangle,
    title: "Ochrana osobních údajů (GDPR)",
    items: [
      "Vaše osobní údaje zpracováváme pouze pro účely realizace pronájmu.",
      "Údaje nikdy nepředáváme třetím stranám bez vašeho souhlasu.",
      "Máte právo kdykoliv požádat o výmaz svých údajů.",
    ],
  },
];

export default function Podminky() {
  return (
    <div className="bg-black" data-testid="podminky-page">
      <section className="container-kame pt-14 pb-10">
        <p className="eyebrow">Vše důležité na jednom místě</p>
        <h1 className="font-display text-4xl sm:text-5xl text-white uppercase mt-2 flex items-center gap-3">
          <FileText className="text-[#B58A50]" size={40} /> Podmínky
        </h1>
        <div className="w-16 h-1 bg-[#B58A50] mt-5" />
      </section>

      <section className="container-kame pb-20 grid md:grid-cols-2 gap-6">
        {SECTIONS.map((s) => (
          <div key={s.title} className="card-kame p-7" data-testid={`podminky-${s.title}`}>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-11 h-11 rounded-sm bg-[#B58A50]/15 flex items-center justify-center text-[#B58A50]">
                <s.icon size={22} />
              </span>
              <h2 className="font-display text-xl text-white uppercase">{s.title}</h2>
            </div>
            <ul className="space-y-3">
              {s.items.map((i) => (
                <li key={i} className="text-white/70 text-sm flex items-start gap-3">
                  <span className="text-[#B58A50] mt-1.5 w-1.5 h-1.5 bg-[#B58A50] rounded-full shrink-0" />
                  {i}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
    </div>
  );
}
